import { API2_HOST } from '@/utils/constants';

import fetchData from './http';
import { IBaseResponse, IResult } from './types/common';
interface IBindFundPasswordParams {
  password: string;
  confirmPassword: string;
}
interface IModifyFundPassword {
  old_password: string;
  password: string;
  confirm_password: string;
  risk_token: string;
}
export function bindFundPassword(params: IBindFundPasswordParams) {
  const url = `${API2_HOST}/user/private/payment-password/add`;
  return fetchData.post<IBaseResponse<IResult>>(url, {
    body: JSON.stringify(params),
  });
}

export function modifyFundPassword(params: IModifyFundPassword) {
  const url = `${API2_HOST}/user/private/payment-password/update`;
  return fetchData.post<IBaseResponse<IResult>>(url, {
    body: JSON.stringify(params),
  });
  // return new Promise((resolve, reject) => {
  //   fetchData
  //     .post<IBaseResponse<IResult>>(url, {
  //       body: JSON.stringify(params),
  //     })
  //     .then((res) => {
  //       resolve(res.result);
  //     })
  //     .catch((error) => {
  //       reject(error.response ? error.response.data : error);
  //     });
  // });
}

export function unbindFundPassword(risk_token: string) {
  const url = `${API2_HOST}/user/private/payment-password/delete`;
  return fetchData.post<IBaseResponse<IResult>>(url, {
    body: JSON.stringify({ risk_token }),
  });
}
